import moment from 'moment';
import { showQueue } from '../products/getters';
import router from '../../../router';
import { getUtmFromRoute } from '../../../utils';

const state = {
  checkoutState: {},
};

async function loadEventData({ dispatch, commit, getters }, eventState) {
  let findedSector = null;

  if (eventState.cartProducts) {
    let productWithSector = null;

    eventState.cartProducts.forEach(products => {
      productWithSector = products.find(product => product.haveSeat);
    });

    if (productWithSector) {
      findedSector = getters.sectors.find(
        sector => sector.codigo === productWithSector.codigo_setor
      );

      if (findedSector) await commit('SET_SELECTED_SECTOR', findedSector);
    }
  }

  dispatch('setBody', eventState.body);
  commit('SET_PRODUCTS_LIST', eventState.cartProducts);
  dispatch('setConfirmationCart', eventState.cartProducts);
  dispatch('setCartProducts', eventState.cartProducts);
  if (eventState.cartProducts.length > 0)
    eventState.cartProducts.forEach(pt => {
      pt.forEach(pd => {
        for (var i = 0; i < pd.quantidade; i++) {
          if (findedSector) {
            let product = findedSector.products.filter(
              el => el.codigo_produto === pd.codigo_produto
            );

            product[0].codigo_obj = pd.codigo_obj;
            product[0].codigo_assento = pd.codigo_assento;
            if (!product[0].seat_id) product[0].seat_id = [];
            product[0].seat_id = pd.seat_id;
            product[0].reserved = true;
          }
          dispatch('addCartProduct', pd);
        }
      });
    });
  dispatch('loadProductsQuantity', eventState.productsQuantity);
  dispatch('loadProductsTotal', eventState.productsTotal);
  if (eventState.deliveryOption) {
    dispatch('loadDeliveryOption', eventState.deliveryOption);
  }
}

const mutations = {
  SAVE_CHECKOUT_INFO(state, eventState) {
    const checkoutState =
      JSON.parse(localStorage.getItem(`checkoutState`)) || {};
    checkoutState[`${eventState.id}`] = {
      ...checkoutState[`${eventState.id}`],
      ...eventState,
    };

    localStorage.setItem(`checkoutState`, JSON.stringify(checkoutState));
    state.checkoutState = checkoutState;
  },
  SET_CHECKOUT_STATE(state, checkoutState) {
    localStorage.setItem(`checkoutState`, JSON.stringify(checkoutState));
    state.checkoutState = checkoutState;
  },
};

const actions = {
  saveCheckoutState: ({ commit }, eventState) => {
    commit('SAVE_CHECKOUT_INFO', eventState);
  },
  loadCheckoutState: async ({ commit, dispatch, getters }, evento) => {
    try {
      commit('SET_SECOND_PAYMENT_STEP', false);
      commit('SET_AME_SELECTED', false);
      commit('SET_AME_DETAILS', null);
      commit('SET_PIX_SELECTED', false);
      commit('SET_PIX_DETAILS', null);
      commit('SET_USER_BILLET_PROPS', {});
      if (getters.pingAme) clearInterval(getters.pingAme);
      if (getters.pingPix) clearInterval(getters.pingPix);
      const signSteps = JSON.parse(localStorage.getItem(`signSteps`)) || {
        logged: false,
        signForm: true,
        step: 0,
      };
      const userProps = JSON.parse(localStorage.getItem(`userProps`)) || {};
      const cupomCode = localStorage.getItem(`cupomCode`);
      const cupomCodeEvent = localStorage.getItem(`cupomCodeEvent`);

      if (cupomCode && cupomCodeEvent === evento) {
        await dispatch('setCupomCode', cupomCode);
      }
      const checkoutState =
        JSON.parse(localStorage.getItem(`checkoutState`)) || {};

      const eventState = checkoutState[evento];

      console.log('router.history.current', router.history.current);
      let haveCouponUrl =
        router.history.current.query && router.history.current.query.c;
      if (haveCouponUrl)
        dispatch('setCupomCode', getUtmFromRoute(router.history.current));

      let hasTicketCodeUrl =
        router.history.current.query &&
        router.history.current.query.codigo_ingresso;
      if (hasTicketCodeUrl)
        dispatch(
          'setTicketCodeUrl',
          router.history.current.query.codigo_ingresso
        );

      let hasProductsCodeUrl =
        router.history.current.query && router.history.current.query.produtos;

      if (hasProductsCodeUrl)
        dispatch('setProductsCodeUrl', router.history.current.query.produtos);

      if (
        (!getters.queue &&
          router.history.current.name !== 'commissioner' &&
          (getters.eventDetails.site_visibilidade !== 'Y' || haveCouponUrl)) ||
        getters.validatedPreSale
      )
        await dispatch('setSectorsList');

      if (
        getters.eventDetails.site_visibilidade === 'Y' &&
        !haveCouponUrl &&
        !getters.validatedPreSale
      ) {
        dispatch('setSkeleton', false);
        commit('SET_SHOW_PRE_SALE', true);
      }
      if (getters.queue && !getters.passedQueue) {
        commit('SET_SHOW_QUEUE', true);
        dispatch('setSkeleton', false);
        commit('SET_CURRENT_STEP', 1);
      }
      if (!eventState) {
        return;
      }
      if (eventState && eventState.productsTotal)
        commit('SET_PARTIAL_VALUE', Number(eventState.productsTotal));
      if (eventState.buyerData) {
        dispatch('setBuyerData', eventState.buyerData);
      }
      if (eventState.body) {
        const currentTimestamp = moment().unix() * 1000;
        if (eventState.body.expiration <= currentTimestamp) {
          dispatch('deleteCheckoutState', evento);
          return;
        }
      }

      switch (eventState.step) {
        case 1:
          loadEventData({ dispatch, commit, getters }, eventState);
          dispatch('setSignSteps', signSteps);
          dispatch('setUserProps', userProps);
          break;
        case 3:
          loadEventData({ dispatch, commit, getters }, eventState);
          if (eventState.userToken) {
            commit('SET_CLIENT_TOKEN', eventState.userToken);
            dispatch('getClientData');
            dispatch('nextStep');
          }
          break;
      }
    } catch (error) {
      throw error;
    }
  },
  deleteCheckoutState: ({ commit, dispatch, getters }, evento) => {
    if (evento) delete state.checkoutState[evento];
    commit('SET_CHECKOUT_STATE', state.checkoutState);
    dispatch('setBuyerData', {});
    dispatch('clearCartData');
    dispatch('setBody', {});
    if (router.history.current.name !== 'commissioner')
      dispatch('setCurrentStep', 1);
    dispatch('setSignSteps', { logged: false, signForm: true, step: 0 });
    dispatch('clearUserProps', {});
    dispatch('setCupomCode', '');
  },
  clearStorage: _ => {
    localStorage.clear();
  },
};

const getters = {
  state(state) {
    return state.checkoutState;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
